import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { bankingPartnerAPI } from '../services/AdminPortal/api';

export const fetchApplicationsByBankId = createAsyncThunk(
  'applications/fetchByBankId',
  async (id, thunkAPI) => {
    const response = await bankingPartnerAPI.getApplicationsByBankId(id);
    if (!response.success) throw new Error(response.message || 'Failed to fetch applications');
    return response.data;
  }
);

const applicationsSlice = createSlice({
  name: 'applications',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationsByBankId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicationsByBankId.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchApplicationsByBankId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default applicationsSlice.reducer; 